<template>
  <div>
    <!-- Check if Node is Empty -->
    <div v-if="node._id">
      <div :style="{ 'margin-left': `${depth * 30}px` }" class="node">
        <!-- &#9660 Down Pointing Arrow Icon -->
        <!-- &#9658 Right Pointing Arrow Icon -->
        <span style="position: absolute; z-index: 1" @click="nodeClicked" v-if="haveChildren && hasID">{{
          expanded ? '&#9660;' : '&#9658;'
        }}</span>

        <span v-else>&#9671;</span>

        <!-- ********************** -->
        <!-- **** Display Name **** -->
        <!-- ********************** -->
        <div class="dropdown pl-4">
          <div v-if="!editNameSwitch">
            <span>{{ node.name }}</span>
            <span v-if="node.value">
              <span v-if="node.meta">
                <span v-if="node.meta.type === 'boolean'">: {{ node.value }}</span>
                <span v-if="node.meta.type === 'text'">: {{ node.value }}</span>
                <span v-if="node.meta.type === 'numeric'">: {{ node.value }} {{ node.meta.uom }}</span>
                <span v-if="node.meta.type === 'numeric array' || node.meta.type === 'numeric-array'"
                  >: {{ node.value[0] }}/{{ node.value[1] }}{{ node.meta.uom }}</span
                >
              </span>
            </span>
          </div>
        </div>
      </div>

      <!-- ******************************* -->
      <!-- **** Recursive Call        **** -->
      <!-- **** Loop through Children **** -->
      <!-- ******************************* -->
      <div v-if="expanded">
        <DisplayAttributes v-for="child in node.children" :key="child.name" :node="child" :depth="depth + 1" />
      </div>
    </div>

    <!-- ******************************************************* -->
    <!-- **** If Node is Please Wait if Display Unavailable **** -->
    <!-- ******************************************************* -->
    <div v-else>
      Please Wait...
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisplayAttributes',
  props: {
    node: Object,
    parent_id: String,
    depth: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {
      expanded: false,
      menuExpandSwitch: true,
      editNameSwitch: false,
      addFieldSwitch: false,
      addChildSwitch: false,
      removeChildSwitch: false,
      editValueSwitch: false,
      deleteCheckSwitch: false,
      editAbbreviationSwitch: false,
      deleteAbbreviationSwitch: false,
      editPrecisionSwitch: false,
      deletePrecisionSwitch: false,
      editValueNameSwitch: false,
      deleteValueNameSwitch: false,
      editUomSwitch: false,
      deleteUomSwitch: false,
      editDisplayHintSwitch: false,
      deleteDisplayHintSwitch: false,
      editUomLongSwitch: false,
      deleteUomLongSwitch: false,
      editTypeSwitch: false,
      deleteTypeSwitch: false,
      addMetaSwitch: false,
    };
  },
  methods: {
    menuExpand() {
      this.menuExpandSwitch = !this.menuExpandSwitch;
    },
    // Switch for this.expanded
    nodeClicked() {
      this.expanded = !this.expanded;
    },
    // Switch for this.editNameSwitch
    editNameField() {
      this.editNameSwitch = !this.editNameSwitch;
      this.menuExpand();
    },
    // Switch for this.addFieldSwitch
    addField() {
      this.addFieldSwitch = !this.addFieldSwitch;
      this.menuExpand();
    },
    // Switch for this.addChildSwitch
    addChild() {
      this.addChildSwitch = !this.addChildSwitch;
      this.menuExpand();
    },
    // Switch for this.addChildSwitch
    removeChild() {
      this.removeChildSwitch = !this.removeChildSwitch;
      this.menuExpand();
    },
    // Switch for this.editValueSwitch
    editValue() {
      this.editValueSwitch = !this.editValueSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteCheckSwitch
    deleteCheck() {
      this.deleteCheckSwitch = !this.deleteCheckSwitch;
      this.menuExpand();
    },
    // Switch for editAbbreviationSwitch
    editAbbreviation() {
      this.editAbbreviationSwitch = !this.editAbbreviationSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteAbbreviationSwitch
    deleteAbbreviationCheck() {
      this.deleteAbbreviationSwitch = !this.deleteAbbreviationSwitch;
      this.menuExpand();
    },
    // Switch for this.editPrecisionSwitch
    editPrecision() {
      this.editPrecisionSwitch = !this.editPrecisionSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteAbbreviationSwitch
    deletePrecisionSwitchCheck() {
      this.deletePrecisionSwitch = !this.deletePrecisionSwitch;
      this.menuExpand();
    },
    // Switch for this.editValueNameSwitch *
    editValueName() {
      this.editValueNameSwitch = !this.editValueNameSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteValueNameSwitch
    deleteValueNameSwitchCheck() {
      this.deleteValueNameSwitch = !this.deleteValueNameSwitch;
      this.menuExpand();
    },
    // Switch for this.editUomSwitch
    editUom() {
      this.editUomSwitch = !this.editUomSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteUomSwitch
    deleteUomSwitchCheck() {
      this.deleteUomSwitch = !this.deleteUomSwitch;
      this.menuExpand();
    },
    // Switch for this.editDisplayHintSwitch
    editDisplayHint() {
      this.editDisplayHintSwitch = !this.editDisplayHintSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteDisplayHintSwitch
    deleteDisplayHintCheck() {
      this.deleteDisplayHintSwitch = !this.deleteDisplayHintSwitch;
      this.menuExpand();
    },
    // Switch for this.editUomLongSwitch
    editUomLong() {
      this.editUomLongSwitch = !this.editUomLongSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteUomLongSwitch
    deleteUomSwitchLongCheck() {
      this.deleteUomLongSwitch = !this.deleteUomLongSwitch;
      this.menuExpand();
    },
    // Switch for this.editTypeSwitch
    editType() {
      this.editTypeSwitch = !this.editTypeSwitch;
      this.menuExpand();
    },
    // Switch for this.deleteTypeSwitch
    deleteTypeSwitchCheck() {
      this.deleteTypeSwitch = !this.deleteTypeSwitch;
      this.menuExpand();
    },
    addMeta() {
      this.addMetaSwitch = !this.addMetaSwitch;
      this.menuExpand();
    },
  },
  computed: {
    // Check for Children
    haveChildren() {
      return this.node.children;
    },
    // Checks for ID to create drop down
    hasID() {
      return this.node._id;
    },
  },
};
</script>

<style scoped>
/* Buttons for Drop Menus */
.button {
  display: block;
  width: 100%;
  border-radius: 0px 0px 0px 0px;
}

/* Wrap around where you what hover effects */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Wrap around menu items */
.dropdown-content {
  margin-left: 25px;
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Drop menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Basic Styling for everything */
.node {
  text-align: left;
  font-size: 18px;
}

/* Styling for field names */
.nameStyle {
  color: #0066ff;
}

/* Styling for field values */
.valueStyle {
  color: #505050;
}
</style>
